import React from 'react'
import { withTranslation } from 'react-i18next'
import Input from 'components/Input'
import LinkItem from 'components/Link'
import { FormBtn } from 'components/Btn'
import { ArrowRight, Info } from 'lucide-react'



export default withTranslation()(function LoginForm({ t, yupFields: { isDirty, isValid }, loginError }) {

  const fields = [
    {
      name: 'email',
      label: t('registration.field.email'),
      placeholder: 'contact@acme.com'
    },
    {
      name: 'password',
      label: t('registration.field.password'),
      placeholder: t('registration.field.password'),
      type: 'password'
    }
  ]

  return (
    <div className="w-full text-center">
      <h1 className="text-2xl font-bold text-black mb-8">{t('registration.login.title')}</h1>

      {
        loginError && (
          <div className="w-full mb-6 px-4 py-3 rounded-lg bg-failure/10 flex items-center gap-2 text-left">
            <Info size={16} className="text-failure shrink-0" />
            <span className="text-failure text-sm font-medium">{loginError}</span>
          </div>
        )
      }

      <div className="flex flex-col gap-4 text-left">
        {
          fields.map(field => {
            return (
              <div key={field.name}>
                <Input
                  name={field.name}
                  label={field.label}
                  placeholder={field.placeholder}
                  type={field?.type}
                  classList="!bg-white !border-border-lines rounded-lg placeholder:text-placeholder"
                />
              </div>
            )
          })
        }
      </div>

      <div className="w-full mt-4 mb-6">
        <LinkItem
          url="/forgot-password"
          tag={() => <span className="text-primary font-medium text-sm inline-flex items-center gap-1">{t('registration.forgot')} <ArrowRight size={14} /></span>}
        />
      </div>

      <FormBtn
        content={() => <span className="flex items-center justify-center gap-2">{t('registration.signin')} <ArrowRight size={16} /></span>}
        className="w-full h-12 text-white rounded-full bg-primary hover:bg-primary"
        disabled={!isValid || !isDirty}
      />

      <p className="mt-4 text-secondary text-sm">
        {t('registration.register')}{' '}
        <LinkItem url="/register" tag={() => <span className="text-primary font-medium">
          {t('registration.signup')}
        </span>}
        />
      </p>
    </div>
  )
})
